import Page from 'modules/app/components/Page';
import TopMenuWithSearchDark from 'modules/feed/components/Feed/TopMenuWithSearchDark';
import React, { useEffect, useState, useCallback } from 'react';
import s from './Venues.module.scss';
import clsx from 'clsx';
import Popular from './Popular';
import VenuesCategories from './VenuesCategories';
import useGetMenuCategories from 'sdk/hooks/salon/useGetMenuCategories';
import SalonFilter from './SalonFilter/SalonFilter';
import useGetSalonView from 'sdk/hooks/salon/useGetSalonView';
import useGetServicesView from 'sdk/hooks/salon/useGetServicesView';
import Search from './Search';
import debounce from 'lodash/debounce';
import { useActions } from 'store/useActions';
import { useTranslation } from 'react-i18next';

const SERVICE_TYPE_TABS = [
  { id: 'all', title: 'All' },
  { id: 'top_rated', title: 'Top Rated' },
  { id: 'good_price', title: 'Good Price' },
  { id: 'best_location', title: 'Best Location' },
] as const;

const Venues = () => {
  const {t} = useTranslation() as any;
  const [searchText, setSearchText] = useState('');
  const [debouncedSearchText, setDebouncedSearchText] = useState('');
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [selectedMenuCategory, setSelectedMenuCategory] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const { data: menuCategories } = useGetMenuCategories();
  const [distances, setDistances] = useState<{ key: string; distance: number }[]>([]);
  const [proximity, setProximity] = useState<number | null>(null);
  const [productId, setProductId] = useState(null);
  const [cityId, setCityId] = useState(null);
  const [brand, setBrand] = useState(null);
  const [minPrice, setMinPrice] = useState(undefined);
  const [maxPrice, setMaxPrice] = useState(undefined);
  const [isAvailable, setIsAvailable] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showSearchHistory, setShowSearchHistory] = useState(true);
  const [rating, setRating] = useState(0);
  const serviceTypeTabs = React.useMemo(() => SERVICE_TYPE_TABS, []);

  const [tab, setTab] = useState<any>('');

  const { setIsButtonMenuVisible } = useActions()


  // const { data: salons, refetch: refetchSalons } = useGetSalonView(
  //   selectedMenuCategory ?? '',
  //   debouncedSearchText,
  //   productId ?? 0,
  //   brand ?? 0,
  //   minPrice,
  //   maxPrice,
  //   isAvailable,
  //   cityId ?? 0,
  //   rating
  // );

  const { data: salons, refetch: refetchSalons } = useGetServicesView(
      selectedMenuCategory ?? '',
      debouncedSearchText,
      cityId ?? 0,
      isAvailable,
      rating
  );

  const debouncedSetSearch = useCallback(
    debounce((value: string) => {
      setDebouncedSearchText(value);
    }, 500),
    []
  );

  useEffect(() => {
    debouncedSetSearch(searchText);
    return () => {
      debouncedSetSearch.cancel();
    };
  }, [searchText, debouncedSetSearch]);

  useEffect(() => {
    if (
      cityId ||
      productId ||
      brand ||
      minPrice !== undefined ||
      maxPrice !== undefined ||
      proximity !== 0
    ) {
      setTab(undefined);
    }
  }, [productId, brand, minPrice, maxPrice, cityId, proximity]);

  useEffect(() => {
    refetchSalons();
  }, [selectedMenuCategory, tab, productId, brand, minPrice, maxPrice, cityId, refetchSalons]);

  useEffect(() => {
    setTab(serviceTypeTabs?.[0]?.id);
  }, [setTab, serviceTypeTabs]);

  const handleSearch = () => {
    setDebouncedSearchText(searchText);
    refetchSalons();
  };
 
  return (
    <div>
      <Page activeLink="/venues">
        <Search
          searchText={searchText}
          setSearchText={setSearchText}
          handleFilterButton={() => {
            setIsButtonMenuVisible(false)
            setShowFilter(true)}}
          isSearchActive={isSearchActive}
          setIsSearchActive={setIsSearchActive}
          onSearch={handleSearch}
          setIsExpanded={setIsExpanded}
          setShowSearchHistory={setShowSearchHistory}
          showSearchHistory={showSearchHistory}
        />
        <div className={s.venues}>
          <div className={clsx(s.venue_tabs)}>
            {serviceTypeTabs.map(item => (
              <div
                key={item.id}
                className={clsx(s.venue_tab, tab === item.id && s.venue_tab_active)}
                onClick={() => setTab(item.id)}
              >
                {t(item.title)}
              </div>
            ))}
          </div>
          <div className={s.subcategories}>
            {menuCategories?.map(item => {
              return (
                <VenuesCategories
                  key={item?.id}
                  item={item}
                  setSelectedMenuCategory={setSelectedMenuCategory}
                  isSelected={selectedMenuCategory === item?.id}
                />
              );
            })}
          </div>
          {tab ? (
            <Popular
              distances={distances}
              setDistances={setDistances}
              salons={salons}
              selectedMenuCategory={selectedMenuCategory}
              productId={productId}
              brand={brand}
              minPrice={minPrice}
              maxPrice={maxPrice}
              cityId={cityId}
              proximity={proximity}
              isExpanded={isExpanded}
              setIsExpanded={setIsExpanded}
              tab={tab}
              minRating={rating}
              debouncedSearchText={debouncedSearchText}
            />
          ) : (
            <Popular
              distances={distances}
              setDistances={setDistances}
              salons={salons}
              selectedMenuCategory={selectedMenuCategory}
              productId={productId}
              brand={brand}
              minPrice={minPrice}
              maxPrice={maxPrice}
              cityId={cityId}
              proximity={proximity}
              isExpanded={isExpanded}
              setIsExpanded={setIsExpanded}
              tab={tab}
              minRating={rating}
              debouncedSearchText={debouncedSearchText}
            />
          )}
        </div>
      </Page>
      <SalonFilter
        open={showFilter}
        setShowFilter={setShowFilter}
        setSelectedMenuCategory={setSelectedMenuCategory}
        setMinPrice={setMinPrice}
        setMaxPrice={setMaxPrice}
        setTab={setTab}
        serviceTypeTabs={serviceTypeTabs}
        maxPrice={maxPrice}
        setIsAvailable={setIsAvailable}
        isAvailable={isAvailable}
        setCityId={setCityId}
        setShowSearchHistory={setShowSearchHistory}
        setIsSearchActive={setIsSearchActive}
        setRating={setRating}
      />
    </div>
  );
};

export default Venues;
